<template lang="pug">
  .stock-select
    v-select(
      v-if="filteredStocks.length"
      :label="'base.stock' | translate"
      :options="filteredStocks"
      v-model="stock"
      @change="onSelected"
      )
    span.text-danger(v-else)
      | {{ 'info.stocks_list_is_empty' | translate }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'StockPanel',

  mounted () {
    const company = +this.$route.params.company_id
    const farm = +this.$route.params.farm_id
    this.loadStocks({ company, farm })
  },

  data: (vm) => ({
    stock: vm.$route.query.stock || '-1',
    stocksLoaded: false
  }),

  computed: {
    ...mapGetters('stocks', [
      'stocks'
    ]),

    filteredStocks () {
      return [
        { id: '-1', name: 'base.all_stocks' },
        ...this.stocks
          .filter(item => (item.farm === null && (item.company && item.company.id) === +this.$route.params.company_id) ||
          (item.farm && item.farm.id) === +this.$route.params.farm_id)
          .map(item => ({
            ...item,
            id: `${item.id}`
          }))
      ]
    }
  },

  methods: {
    ...mapActions('stocks', [
      'loadStocks'
    ]),
    onSelected (val) {
      this.$emit('update-stock-data', val)
    }
  },

  watch: {
    stock (id) {
      const { path, params, query } = this.$route
      const { page, ...restQuery } = query
      this.$router.push({
        path,
        params,
        query: {
          ...restQuery,
          stock: id
        }
      })
      this.$emit('update-stock-data', id, page)
    }
  }
}
</script>

<style lang="scss">
.stock-select {
  height: 7rem;
  display: flex;
  align-items: center;
  padding: 2rem 2.5rem 1rem;
  margin-bottom: 0.8rem;
  background-color: var(--color-surface);
  border-radius: 1rem;
  padding: 5rem 2.5rem;
  margin-bottom: 1rem;
  border-radius: 6px;
  .v-select-wrapper,
  .v-select {
    width: 100%;
  }
}
</style>
